module.exports = __webpack_public_path__ + "js/components/images/applestore_white-9739a6e4428502dd35360e21ee736199.svg";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/applestore_white.svg
// module id = 821
// module chunks = 31